import script from "./login-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./login-modal.vue?vue&type=script&setup=true&lang=ts"

import "./login.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__